import { z } from "zod";

export const requestIdSchema = z.uuid();

export const demoMetadataSchema = z.object({
  name: z.string().min(1),
  description: z.string().min(1),
  version: z.string().min(1),
  environment: z.string().min(1),
  dataNotice: z.string().min(1),
  canonicalHost: z.string().min(1).optional(),
});

export const healthResponseSchema = z.object({
  ok: z.literal(true),
  data: z.object({
    status: z.literal("ok"),
    service: z.string().min(1),
    version: z.string().min(1),
    checkedAt: z.iso.datetime(),
  }),
  requestId: requestIdSchema,
});

export const metaResponseSchema = z.object({
  ok: z.literal(true),
  data: demoMetadataSchema,
  requestId: requestIdSchema,
});

export const apiErrorResponseSchema = z.object({
  ok: z.literal(false),
  error: z.object({
    code: z.string().min(1),
    message: z.string().min(1),
  }),
  requestId: requestIdSchema,
});

export type DemoMetadata = z.infer<typeof demoMetadataSchema>;
export type HealthResponse = z.infer<typeof healthResponseSchema>;
export type MetaResponse = z.infer<typeof metaResponseSchema>;
export type ApiErrorResponse = z.infer<typeof apiErrorResponseSchema>;
